import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import './Pie.scss'

function Pie(props) {  
    var seriesData = []
    props.slices.forEach(element => {
        if (element["percent"] !== 0) { // exclude elements with RestPct < 0.5%
            element["y"] = element["percent"]
            seriesData.push(element)
        }
    });
    const format = props.isAnswerComponent ? '<br>{point.content}' 
        : '<br>{point.percentage:.1f} %'

    var options = {
        chart: {
            type: 'pie',
            // maxHeight: '60%',
        },
        title: {
            text: null
        },
        series: [{
            data: seriesData
        }],
        colors: ['#B2292D', '#f4d06f', '#5B6586', '#E7DCDA'],
        legend: {
            enabled: false
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: format,
                style: {
                    fontSize: '14pt',
                }
              },
              size: '50%'
            }
          },
      }

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
            containerProps={{ className: "pie-container" }} 
        />
    );
}

export default Pie;
